import styled from 'styled-components';

export const CoursesContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.grey15};
  padding: ${({ theme }) => theme.spacing.m};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-block: ${({ theme }) => theme.spacing.s};
`;

export const CoursesTitle = styled.h4`
  color: ${({ theme }) => theme.colors.grey6};
  margin-bottom: ${({ theme }) => theme.spacing.s};
  .italicSpan {
    font-size: 1rem;
  }
`;

export const CoursesSelect = styled.select`
  flex: 1; /* Makes the select dropdown take up available space */
  padding: ${({ theme }) => theme.spacing.s};
  border: 1px solid ${({ theme }) => theme.colors.grey25};
  border-radius: ${({ theme }) => theme.borderRadius};
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.grey6};
  font-size: 1rem;
  margin-right: ${({ theme }) =>
    theme.spacing.s}; /* Adds spacing between select and button */
  transition: border-color 0.3s ease;

  &:focus {
    border-color: ${({ theme }) => theme.colors.yellow5};
    outline: none;
  }
`;

export const CoursesActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between; /* Spaces the select and button to opposite ends */
  margin-top: ${({ theme }) => theme.spacing.s};

  button {
    padding: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.m};
    background-color: ${({ theme }) => theme.colors.yellow5};
    color: ${({ theme }) => theme.colors.white};
    border: none;
    border-radius: ${({ theme }) => theme.borderRadius};
    cursor: pointer;
    transition:
      background-color 0.3s ease,
      transform 0.2s ease;

    &:hover {
      background-color: ${({ theme }) => theme.colors.orange2};
      transform: scale(1.05);
    }
  }
`;

export const StatusMessage = styled.p`
  margin-top: ${({ theme }) => theme.spacing.s};
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.grey6};
`;
